export class Company {
    companyId: number;
    name: string;
    code1: string;
    code2: string;
    status: number;
    isDefault: boolean;
    categoryAccountingCodeRule: number;
    organisationId: number;
    multipleCountryId: number;
    createdBy: number;
    createdOn: Date;
    updatedBy: number;
    updatedOn: Date;
}

//Get CompanyByOrgId Request
export interface ICompanyListRequest {
    organisationId: number;
}

export class CompanyListRequest implements ICompanyListRequest {
    organisationId: number;
    constructor(organisationId: number) {
        this.organisationId = organisationId
    }
}

//Get CompanyByOrgId Response
export interface ICompanyListResponse {
    companyList: ICompanyResponse[];
    totalCompaniesCount: number;
    activeCompaniesCount: number;
    inActiveCompaniesCount: number;
}

//Company Response
export interface ICompanyResponse {
    srNo: string;
    companyId: number;
    name: string;
    code1: string;
    code2: string;
    status: number;
    isDefault: boolean;
    categoryAccountingCodeRule: number;
    organisationId: number;
    multipleCountryId: number;
    countryName: string;
    currencyCode: string;
    assignedEmployeesCount: number;
    createdBy: number;
    createdOn: Date;
    updatedBy: number;
    updatedOn: Date;
    isRowHighlighted: boolean;
    totalFinanceManagerCount: number;
    otherFinanceManagerCount: number;
    financeManagers: string;
    isAddedNewCategoryReminder: boolean;
    isCheckboxDisabled: boolean;
    isAccIntLinked: boolean;
    accSysName: string;
    accSysId: number;
    statusData: any;
    financeManager1: string;
    financeManager2: string;
    financeManager3: string;
    financeManager4: string;
    financeManager1Id: number;
    financeManager2Id: number;
    financeManager3Id: number;
    isTooltipTextDisplay: boolean;
    tooltipText: string;
    accountingCode: string;
    removeRightsLink: string;
    financeManager4Id: number;
    expPendingWithApprover: number;
    expPendingWithFinanceApprover: number;
    expPassedForPayment: number;
    disableDeactivate: boolean;
    currencyName: string;
}

export class CompanyResponse implements ICompanyResponse {
    srNo: string;
    companyId: number;
    name: string;
    code1: string;
    code2: string;
    status: number;
    isDefault: boolean;
    categoryAccountingCodeRule: number;
    organisationId: number;
    multipleCountryId: number;
    countryName: string;
    currencyCode: string;
    assignedEmployeesCount: number;
    createdBy: number;
    createdOn: Date;
    updatedBy: number;
    updatedOn: Date;
    isRowHighlighted: boolean;
    totalFinanceManagerCount: number;
    otherFinanceManagerCount: number;
    financeManagers: string;
    isAddedNewCategoryReminder: boolean;
    isCheckboxDisabled: boolean;
    isAccIntLinked: boolean;
    accSysName: string;
    accSysId: number;
    statusData: any;
    financeManager1: string;
    financeManager2: string;
    financeManager3: string;
    financeManager4: string;
    financeManager1Id: number;
    financeManager2Id: number;
    financeManager3Id: number;
    isTooltipTextDisplay: boolean;
    tooltipText: string;
    accountingCode: string;
    removeRightsLink: string;
    financeManager4Id: number;
    expPendingWithApprover: number;
    expPendingWithFinanceApprover: number;
    expPassedForPayment: number;
    disableDeactivate: boolean;
    currencyName: string;
}

//Company Request

export class CompanyRequest extends Company {
    userName: string;
    countryName: string;
    currencyCode: string;
    newCompanyId: number;
}

//BulkCompanyAssignToEmployeeRequest
export interface IBulkCompanyAssignToEmployeeRequest {
    companyId: number;
    updatedBy: number;
    companyName: string;
    organisationId: number;
    userName: string;
    userOrgMappingIds: number[];
}

export class BulkCompanyAssignToEmployeeRequest implements IBulkCompanyAssignToEmployeeRequest {
    companyId: number;
    updatedBy: number;
    companyName: string;
    organisationId: number;
    userName: string;
    userOrgMappingIds: number[];

    constructor(companyId: number, updatedBy: number, companyName: string, organisationId: number, userName: string, userOrgMappingIds: number[]) {
        this.companyId = companyId;
        this.updatedBy = updatedBy;
        this.companyName = companyName;
        this.organisationId = organisationId;
        this.userName = userName;
        this.userOrgMappingIds = userOrgMappingIds;
    }

}


//Get GetCompanyEmployeeList Request-Response
export interface ICompanyEmployeeListRequest {
    organisationId: number;
    companyId: number;
}

export class CompanyEmployeeListRequest implements ICompanyEmployeeListRequest {
    organisationId: number;
    companyId: number;
    constructor(organisationId: number, companyId: number) {
        this.organisationId = organisationId,
            this.companyId = companyId
    }
}


export interface ICompanyEmployeeListResponse {
    companyEmployeeList: ICompanyEmployeeResponse[];
    totalCompanyEmployeeCount: number;
}

export interface ICompanyEmployeeResponse {
    employeeId: number;
    employeeName: string;
    employeeEmail: string;
    employeeStatus: number;
    employeeRole: number;
    userOrgMappingId: number;
    selected: boolean;
}

export class CompanyEmployeeListPanelInputModel {
    companyId: number;
    companyName: string;
    constructor(companyId: number, companyName: string) {
        this.companyId = companyId;
        this.companyName = companyName;

    }
}


export class AddCompanyPanelInputModel {
    companyId: number;
    isEditMode: boolean;
    accSysId: number;
    constructor(companyId: number, isEditMode: boolean, accSysId: number = 0) {
        this.companyId = companyId;
        this.isEditMode = isEditMode;
        this.accSysId = accSysId;
    }
}

export class AddCompanyPanelOutputModel {
    filterStatus: number;
    constructor(filterStatus: number) {
        this.filterStatus = filterStatus;
    }
}

export interface IActiveCompanyForSelectionResponse {
    companyId: number;
    name: string;
    companyCountryName: string;
    currencyId: number;
    currencyCode: string;
    assignedEmployeesCount: number;
    currencyName: string;
    countryName: string;
}

export class ActiveCompanyForSelectionResponse implements IActiveCompanyForSelectionResponse {
    companyId: number;
    name: string;
    companyCountryName: string;
    currencyId: number;
    currencyCode: string;
    assignedEmployeesCount: number;
    currencyName: string;
    countryName: string;
}


//Get Request
export interface IEmployeeListForCompanyAssignmentRequest {
    organisationId: number;
}

export class EmployeeListForCompanyAssignmentRequest implements IEmployeeListForCompanyAssignmentRequest {
    organisationId: number;
    constructor(organisationId: number) {
        this.organisationId = organisationId
    }
}

//Get CompanyByOrgId Response
export interface IEmployeeListForCompanyAssignmentResponse {
    employeeList: IEmployeeForCompanyAssignmentResponse[];
    totalCompaniesCount: number;
    totalEmployessCount: number;
}

//Company Response
export interface IEmployeeForCompanyAssignmentResponse {
    userOrgMappingId: number;
    employeeId: number;
    employeeName: string;
    employeeEmail: string;
    employeeCode: string;
    companyId: number;
    companyName: string;
    status: number;
    updatedOn: number;
    isRowHighlighted: boolean;
    selected: boolean;
    expPendingWithApprover: number;
    expPendingWithFinanceApprover: number;
    expPassedForPayment: number;
    isAnyPendingExp: boolean;
}

export class EmployeeForCompanyAssignment {
    userOrgMappingId: number;
    employeeName: string;
    companyId: number;
    companyName: string;
    employeeId: number;
}

export class AssignAccountCodePopupModel {
    constructor(
        public title: string,
        public companyId: number,
        public categoryAccountingCodeRule: number,
        public companyName: string
    ) {

    }
}


export class SetupCompanyRulesPopupModel {
    constructor(
        public title: string,
        public companyId: number,
        public companyName: string,
        public highlightedUserId: number,
        public isChangeRoleLinkVisible: boolean
    ) {

    }
}



//GetAssignAccountingCodeToCompanyGrid Request
export interface IAssignAccountingCodeToCompanyGridRequest {
    organisationId: number;
}

export class AssignAccountingCodeToCompanyGridRequest implements IAssignAccountingCodeToCompanyGridRequest {
    organisationId: number;

    constructor(organisationId: number) {
        this.organisationId = organisationId
    }
}

//Get GetAssignAccountingCodeToCompanyGrid Response
export interface IAssignAccountingCodeToCompanyGridResponse {
    companyList: ICompanyResponse[];
    totalCompaniesCount: number;
}



//GetExpenseCategoriesForCompany Request
export interface IExpenseCategoriesForCompanyRequest {
    organisationId: number;
    companyId: number;
}

export class ExpenseCategoriesForCompanyRequest implements IExpenseCategoriesForCompanyRequest {
    organisationId: number;
    companyId: number;
    constructor(organisationId: number, companyId: number) {
        this.organisationId = organisationId,
            this.companyId = companyId
    }
}

// ICompanyExpenseCategoriesResponse
export interface IExpenseCategoriesForCompanyResponse {
    orgExpenseCategoryId: number;
    organisationId: number;
    baseCategoryId: number;
    expenseCategoryName: string;
    accountingCode: string;
    clientAccountingCode: string;
    guestAccountingCode: string;
    tipsAccountingCode: string;
    companyId: number;
    companyAccountingCode: string;
    companyEmployeeAccountingCode: string;
    companyGuestAccountingCode: string;
    companyTipsAccountingCode: string;
    companyCategoryAccountingCodeAssignmentId: number;
    createdBy: number;
    createdOn: number;
    updatedBy: number;
    updatedOn: number;
}

//update accounting category rule
export interface IUpdateCompanyCategoryAccountingCodeRuleRequest {
    organisationId: number;
    companyId: number;
    categoryAccountingCodeRule: number;
    updatedBy: number;
    updatedOn: number;
    UserName: string;
    companyCategoriesList: ICompanyCategoryAccountingCodeAssignmentRequest[];

}
export class UpdateCompanyCategoryAccountingCodeRuleRequest implements IUpdateCompanyCategoryAccountingCodeRuleRequest {
    organisationId: number;
    companyId: number;
    categoryAccountingCodeRule: number;
    updatedBy: number;
    updatedOn: number;
    UserName: string;
    companyCategoriesList: ICompanyCategoryAccountingCodeAssignmentRequest[];
}

export class CompanyCategoryAccountingCodeAssignmentRequest
    implements ICompanyCategoryAccountingCodeAssignmentRequest {
    companyCategoryAccountingCodeAssignmentId: number;
    companyId: number;
    orgExpenseCategoryId: number;
    baseCategoryId: number;
    accountingCode: string;
    employeeAccountingCode: string;
    guestAccountingCode: string;
    tipsAccountingCode: string;
    createdBy: number;
    createdOn: number;
    updatedBy: number;
    updatedOn: number;
}
export interface ICompanyCategoryAccountingCodeAssignmentRequest {
    companyCategoryAccountingCodeAssignmentId: number;
    companyId: number;
    orgExpenseCategoryId: number;
    baseCategoryId: number;
    accountingCode: string;
    employeeAccountingCode: string;
    guestAccountingCode: string;
    tipsAccountingCode: string;
    createdBy: number;
    createdOn: number;
    updatedBy: number;
    updatedOn: number;
}


export interface ICompanyExpenseCategoryFormModel {
    expenseCategoryName: string;
    masterAccountingCode: string;
    companyCategoryAccountingCodeAssignmentId: number;
    companyId: number;
    orgExpenseCategoryId: number;
    baseCategoryId: number;
    accountingCode: string;
    employeeAccountingCode: string;
    guestAccountingCode: string;
    tipsAccountingCode: string;
    createdBy: number;
    createdOn: number;
    updatedBy: number;
    updatedOn: number;
    isValid: boolean;
    disabled: boolean;
    showCheckBoxWithText: boolean;
    showCheckBoxWithText1: boolean;
    isShowText: boolean;
    selected: boolean;
}


export interface IOrgCompanyApproverRuleResponse {
    companyApproverRule: number;
}


//SaveOrgCompanyApproverRuleRequest
export interface ISaveOrgCompanyApproverRuleRequest {
    organisationId: number;
    companyApproverRule: number;
    updatedBy: number;
    updatedOn: number;
    oldRuleName: string;
    newRuleName: string;
    userName: string;
}

export class SaveOrgCompanyApproverRuleRequest implements ISaveOrgCompanyApproverRuleRequest {
    organisationId: number;
    companyApproverRule: number;
    updatedBy: number;
    updatedOn: number;
    oldRuleName: string;
    newRuleName: string;
    userName: string;

    constructor(organisationId: number, companyApproverRule: number, updatedBy: number, updatedOn: number, oldRuleName: string, newRuleName: string, userName: string) {
        this.organisationId = organisationId;
        this.companyApproverRule = companyApproverRule;
        this.updatedBy = updatedBy;
        this.updatedOn = updatedOn;
        this.oldRuleName = oldRuleName;
        this.newRuleName = newRuleName;
        this.userName = userName;
    }

}


//Get CompanyByOrgId Response
export interface ISetupCompanyRulesGridResponse {
    companyList: ICompanyResponse[];
    totalCompaniesCount: number;
    totalFinanceManagerCount: number;
    withOneFinanceManagerCount: number;
    withTwoFinanceManagersCount: number;
    withThreeFinanceManagersCount: number;
    withMoreThanThreeFinanceManagersCount: number;
}

export interface ISetupCompanyRulesGridRequest {
    organisationId: number;
}

export class SetupCompanyRulesGridRequest implements ISetupCompanyRulesGridRequest {
    organisationId: number;
    constructor(organisationId: number) {
        this.organisationId = organisationId
    }
}


//Get CompanyFinanceManagersRulesDetailsResponse
export interface ICompanyFinanceManagersRulesDetailsResponse {
    companyFinanceManagersWithAssignedRuleList: ICompanyFinanceManagersWithAssignedRuleResponse[];
    approvingExpensesCount: number;
    payingExpensesCount: number;
}

export interface ICompanyFinanceManagersRulesDetailsRequest {
    organisationId: number;
    companyId: number;
}

export class CompanyFinanceManagersRulesDetailsRequest implements ICompanyFinanceManagersRulesDetailsRequest {
    organisationId: number;
    companyId: number;
    constructor(organisationId: number, companyId: number) {
        this.organisationId = organisationId,
            this.companyId = companyId
    }
}

//CompanyFinanceManagersWithAssignedRuleResponse
export interface ICompanyFinanceManagersWithAssignedRuleResponse {
    userId: number;
    fullName: string;
    email: string;
    userOrgMappingId: number;
    fmCompanyId: number;
    fmCompanyName: string;
    organisationId: number;
    companyFMAssignmentId: number;
    companyId: number;
    financeManagerId: number;
    isApprovingChecked: boolean;
    isPayingChecked: boolean;
    createdBy: number;
    createdOn: Date;
    updatedBy: number;
    updatedOn: Date;
    changeRoleLink: string;
    displayText: string;
    isRowHighlighted: boolean;
    hiddenColumn: string;
}




//SaveCompanyFMAssignment
export interface ISaveCompanyFMAssignmentRequest {
    companyId: number;
    updatedBy: number;
    updatedOn: number;
    financeManagersWithAssignedRuleList: ICompanyFMAssignmentRequest[];

}
export class SaveCompanyFMAssignmentRequest implements ISaveCompanyFMAssignmentRequest {
    companyId: number;
    updatedBy: number;
    updatedOn: number;
    financeManagersWithAssignedRuleList: ICompanyFMAssignmentRequest[];
}

export class CompanyFMAssignmentRequest
    implements ICompanyFMAssignmentRequest {
    companyFMAssignmentId: number;
    companyId: number;
    financeManagerId: number;
    isApprovingChecked: boolean;
    isPayingChecked: boolean;
    createdBy: number;
    createdOn: number;
    updatedBy: number;
    updatedOn: number;
}
export interface ICompanyFMAssignmentRequest {
    companyFMAssignmentId: number;
    companyId: number;
    financeManagerId: number;
    isApprovingChecked: boolean;
    isPayingChecked: boolean;
    createdBy: number;
    createdOn: number;
    updatedBy: number;
    updatedOn: number;
}


export interface ICompanyListAssignedToFMRequest {
    organisationId: number;
    financeManagerId: number;
}

export class CompanyListAssignedToFMRequest implements ICompanyListAssignedToFMRequest {
    organisationId: number;
    financeManagerId: number;
    constructor(organisationId: number, financeManagerId: number) {
        this.organisationId = organisationId,
            this.financeManagerId = financeManagerId
    }
}


export class ReplaceCompanyFmPopupModel {
    constructor(
        public title: string,
        public userId: number
    ) {

    }
}


export interface IFinanceManagerIdResponse {
    financeManagerId: number;
}

export interface IPendingExpensesCountOfCompanyRequest {
    organisationId: number;
    companyId: number;
}

export class PendingExpensesCountOfCompanyRequest implements IPendingExpensesCountOfCompanyRequest {
    organisationId: number;
    companyId: number;

    constructor(organisationId: number, companyId: number) {
        this.organisationId = organisationId;
        this.companyId = companyId;

    }
}

export class CompanyFormModel extends Company {
    isEditMode: boolean;
    companyToggle: boolean;
    isCode1Focus: boolean = false;
    countryName: string;
    currencyCode: string;
    assignedEmployeesCount: number;
    newCompanyId: number;
    newCurrencyId: number;
    newCurrencyCode: string;
    newCurrencyName: string;
    currencyName: string;
}

export class ReassignCompanyPanelInputModel {
    constructor(public companyId: number, public companyName: string, public assignedEmployeesCount: number) {

    }
}

export class ReassignCompanyFormModel {
    public newCompanyId: number;
}

export class ReassignCompanyPanelOutputModel {
    constructor(
        public newCompanyId: number,
        public newCurrencyId: number,
        public newCurrencyCode: string,
        public newCurrencyName: string
    ) {

    }
}

export class AssignFmsToCompanyListPanelInputModel {
    companyId: number;
    companyName: string;
    constructor(companyId: number, companyName: string) {
        this.companyId = companyId;
        this.companyName = companyName;

    }
}

export interface IAssignedFinanceManagersToCompanyRequest {
    organisationId: number;
    companyId: number;
}

export class AssignedFinanceManagersToCompanyRequest implements IAssignedFinanceManagersToCompanyRequest {
    organisationId: number;
    companyId: number;
    constructor(organisationId: number, companyId: number) {
        this.organisationId = organisationId,
            this.companyId = companyId
    }
}
export class CompanyEntertainmentCatFormModel {
    expenseCategoryName: string;
    orgExpenseCategoryId: number;
    employeeAccountingCode: string;
    guestAccountingCode: string;
    tipsAccountingCode: string;
    disabled: boolean;
}

export class CompanyEntertainmentCatPopupModel {

    constructor(
        public expenseCategoryName: string,
        public orgExpenseCategoryId: number,
        public employeeAccountingCode: string,
        public guestAccountingCode: string,
        public tipsAccountingCode: string,
        public disabled: boolean
    ) {

    }
}




//Assigned FinanceManagers To Company Response
export interface IAssignedFinanceManagersToCompanyResponse {
    userId: number;
    fullName: string;
    email: string;
}

export class AssignedFinanceManagersToCompanyResponse implements IAssignedFinanceManagersToCompanyResponse {
    userId: number;
    fullName: string;
    email: string;
}

export class CompaniesAssignToFmPanelInputModel {
    financeManagerId: number;
    financeManagerName: string;
    constructor(financeManagerId: number, financeManagerName: string) {
        this.financeManagerId = financeManagerId;
        this.financeManagerName = financeManagerName;

    }
}

export class GetCompaniesAssignedToFinanceManagerRequest implements IGetCompaniesAssignedToFinanceManagerRequest {
    organisationId: number;
    financeManagerId: number;
    constructor(organisationId: number, financeManagerId: number) {
        this.organisationId = organisationId;
        this.financeManagerId = financeManagerId;
    }
}

export interface IGetCompaniesAssignedToFinanceManagerRequest {
    organisationId: number;
    financeManagerId: number;
}

export class AssignAccountingCodeToCompanyListPanelInputModel {
    title: string;
    constructor(title: string) {
        this.title = title;
    }
}

export interface ICompanyDetailsForUnsubscribe {
    companyList: ICompanyResponse[];
    defaultCompany: ICompanyResponse;
    companyWithPeningExpenseCount: number;
}


export class CompanyPendingExpenseListPanelInputModel {
    companyId: number;
    companyName: string;
    expenseStatus: number;
    constructor(companyId: number, companyName: string, expenseStatus: number) {
        this.companyId = companyId;
        this.companyName = companyName;
        this.expenseStatus = expenseStatus;
    }
}




export interface IPendingCompanyExpenseRequest {
    companyId: number;
    organisationId: number;
    expenseStatus: number;
}

export class PendingCompanyExpenseRequest implements IPendingCompanyExpenseRequest {
    companyId: number;
    organisationId: number;
    expenseStatus: number;
    constructor(companyId: number, organisationId: number, expenseStatus: number) {
        this.companyId = companyId;
        this.organisationId = organisationId;
        this.expenseStatus = expenseStatus;
    }
}

export interface IPendingExpenseResponse {
    expenseId: number;
    claimantName: string;
    claimantEmail: string;
    claimantId: number;
    orgExpenseCategory: string;
    orgExpenseCategoryId: number;
    amount: number;
    approverId: number;
    approverName: string;
    approverEmail: string;
    financeApproverId: number;
    financeApproverName: string;
    financeApproverEmail: string;
}

export interface IBulkSendReminderToApproverRequest {
    organisationId: number;
    approverIds: number[];
}

export class BulkSendReminderToApproverRequest implements IBulkSendReminderToApproverRequest {
    organisationId: number;
    approverIds: number[];

    constructor(organisationId: number, approverIds: number[]) {
        this.organisationId = organisationId;
        this.approverIds = approverIds;
    }

}


export class EmployeePendingExpenseListPanelInputModel {
    employeeId: number;
    employeeName: string;
    expenseStatus: number;
    constructor(employeeId: number, employeeName: string, expenseStatus: number) {
        this.employeeId = employeeId;
        this.employeeName = employeeName;
        this.expenseStatus = expenseStatus;
    }
}

export interface IUserPendingExpenseRequest{
    employeeId: number;
    organisationId: number;
    expenseStatus: number;
    userId: number;
}

export class UserPendingExpenseRequest implements IUserPendingExpenseRequest {
    employeeId: number;
    organisationId: number;
    expenseStatus: number;
    userId: number;
    constructor(employeeId: number, organisationId: number, expenseStatus: number,userId: number) {
        this.employeeId = employeeId;
        this.organisationId = organisationId;
        this.expenseStatus = expenseStatus;
        this.userId = userId;
    }
}

export class CompanyCardAccessGrantDetailResponse{
    companyList: CompanyCardAccessGrantDetail[];
}
export class CompanyCardAccessGrantDetail
 {
     companyCardAccessGrantsId: number;
     companyId: number;
     companyName: string;
     isAccessAssigned: boolean;
     isJustificationRequired: boolean;
     isCompanyCardAssigned: boolean;
     status: number;
 }

 export class DetailsForCompanyCardAccessGrantRequest
  {
     organisationId: number;
     userId : number;
  }

  export class CompanyCardAccessGrantClaimant{
  userId: number;
  fullName: string;
  primaryEmail: string;    
  companyWithCardAccessCount: number;
  companyWithOnlyAccessCount: number;
  companyAccessRequestCount: number;
  isRowHighlighted: boolean;
  updatedOn: number;
}

export class CompanyCardAccessGrantClaimantRequest{
  organisationId : number;
}

  export class CCCompanyAccessGrantPanelInputModel{
    userId: number;
    userName: string;
  }

  export class SaveCompanyCardAccessGrantsMappingRequest{
      userId: number;
      organisationId: number;
      companyCardAccessMapping: CompanyCardAccessGrantsMapping[];
      updatedBy: number;
      userName: string;
  }
  export class CompanyCardAccessGrantsMapping{
      companyId: number;
      isJustificationRequired: boolean;
      status: number;
  } 

  export class SaveCompanyCardAccessGrantsRequest{
     companyCardAccessGrantsId: number;
     userId: number;
     organisationId: number;
     companyId: number;
     isJustificationRequired: boolean;
     status: number;
     updatedBy: number;
     userName:string;
  }

 export class CCCompanyAccessGrantRequestPanelInputModel{
    userId: number;
    userName: string;
    email: string;
    companyCardAccessGrantsId: number;
  }
